const fb = require("../firebase.js");

export default {
  namespaced: true,
  state: {
    gardens: [],
    gardensPending: false,
    gardensError: null,
    garden: {},
    gardenPending: false,
    gardenError: null,
    gardenIsLoved: false,
    gardenNumberOfLovers: 0,
    gardenNumberOfLoversPending: false,
    gardenNumberOfLoversError: null
  },
  mutations: {
    setGardens (state, value) {
      state.gardens = value
    },
    setGardensPending (state, value) {
      state.gardensPending = value
    },
    setGardensError (state, value) {
      state.gardensError = value
    },
    setGarden (state, value) {
      state.garden = value
    },
    updateGarden (state, value) {
      state.garden = { ...state.garden, ...value } 
    },
    setGardenPending (state, value) {
      state.gardenPending = value
    },
    setGardenError (state, value) {
      state.gardenError = value
    },
    setGardenIsLoved (state, value) {
      state.gardenIsLoved = value
    },
    setGardenNumberOfLovers (state, value) {
      state.gardenNumberOfLovers = value
    },
    setGardenNumberOfLoversPending (state, value) {
      state.gardenNumberOfLoversPending = value
    },
    setGardenNumberOfLoversError (state, value) {
      state.gardenNumberOfLoversError = value
    },
  },
  actions: {
    getGardens({state, commit, rootState}){
      commit('setGardensPending', true)
      fb.db.collection("gardens").orderBy("position").limit(50)
        .get()
        .then((querySnapshot) => {
          let gardens = []
          querySnapshot.forEach((doc) => {
            gardens.push({ id: doc.id, ...doc.data() })
          });
          commit('setGardens', gardens)
          commit('setGardensPending', false)
        })
        .catch((error) => {
          commit('setGardensPending', false)
          commit('setGardensError', error)
        })
    },
    async getGarden ({ commit }, gardenId) {
      if (!gardenId && !fb.firebase.auth().currentUser) return
      commit('setGardenPending', true)
      return await fb.db.collection("gardens").doc(gardenId?gardenId:fb.firebase.auth().currentUser.uid).get().then((doc) => {
        if (doc.exists) {
          commit('setGarden', { id: doc.id, ...doc.data() } )
          commit('setGardenPending', false)
          return { id: doc.id, ...doc.data() }
        } else {
          commit('setGardenPending', false)
          return console.log("No such document!");
        }
        
      }).catch((error) => {
        commit('setGardenPending', false)
        commit('setGardenError', error)
      })
    },
    
    async updateGarden ({ commit, state }, update ) {
      commit('setGardenPending', true)
      commit("setGarden", {...state.garden, ...update})
      if (update.position) update.position =  new fb.firebase.firestore.GeoPoint(update.position.lat, update.position.lng)
      await fb.db
        .collection("gardens")
        .doc(fb.firebase.auth().currentUser.uid)
        .update(update).then((data)=>{
          commit('setGardenPending', false)
          return 
        }).catch((error) => {
          commit('setGardenError', error)
          commit('setGardenPending', false)
        });
      return "next"
      
    }
  }
}
  